import { render, staticRenderFns } from "./RmBatchTastePanelSummery.vue?vue&type=template&id=1d258254&"
import script from "./RmBatchTastePanelSummery.vue?vue&type=script&lang=js&"
export * from "./RmBatchTastePanelSummery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports